import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Space } from "antd";
import React from "react";
import { TaskNameSelect } from "./TaskNameSelect";

interface TaskListProps {
  name: string | number | (string | number)[];
  targets?: string[];
}

export const TaskList = (props: TaskListProps) => {
  return (
    <Form.List name={props.name}>
      {(fields, { add, remove }) => (
        <Space direction="vertical">
          {fields.map((field) => (
            <Space key={field.key} direction="horizontal" align="baseline">
              <Form.Item {...field} name={[field.name, "name"]} label="Task">
                <TaskNameSelect
                  style={{ width: "40%", minWidth: "250px" }}
                  placeholder="Select Task"
                />
              </Form.Item>
              <Form.Item name={[field.name, "target"]} label="Target">
                <Select
                  placeholder="Target name"
                  style={{ width: "40%", minWidth: "250px" }}
                  options={[
                    { value: "system", label: "system" },
                    ...(props.targets?.map((target) => ({
                      value: target,
                      label: target,
                    })) ?? []),
                  ]}
                />
              </Form.Item>
              <Form.Item name={[field.name, "value"]} label="Value">
                <Input placeholder="Value" />
              </Form.Item>
              <MinusCircleOutlined
                
                onClick={() => remove(field.name)}
              />
            </Space>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              icon={<PlusCircleOutlined  />}
            >
              Add Task
            </Button>
          </Form.Item>
        </Space>
      )}
    </Form.List>
  );
};
